module.exports = __webpack_public_path__ + "img/business_26.291b3b3a.jpg";